module.exports = __webpack_public_path__ + "static/media/TA.90ebddb1.jpg";